import * as React from "react";
import { makeCapabilityAiClient } from "@eduviaos/shared";
import type { ApplyResult, CapabilityPromptContextWire, TargetKind } from "@eduviaos/shared";
import { useCapabilityAiAssistController } from "@eduviaos/capability-ai-ui";
import type { CapabilityAiAssist } from "@eduviaos/capability-ai-ui";
import { api } from "@/lib/api";

/**
 * Phase F-finale-5 Slice 5b — institution-admin binding for the shared
 * capability-AI drawer controller.
 *
 * Unlike the SA wrapper (`useSaCapabilityAiAssist`), this builds the
 * **self-scoped** client (`makeCapabilityAiClient`) which hits the bare
 * `/ai/capability/*` routes. The tenant is resolved BE-side from the IA `api`
 * singleton's `X-Tenant-Slug` header + JWT — never a path slug — so a tenant
 * admin can only ever assist their own forms. The state machine, prompt-context
 * seam, and BE error mapping are shared with SA via the controller.
 */

export interface UseIaCapabilityAiAssistOptions {
  targetKind: TargetKind;
  buildContext: () => CapabilityPromptContextWire;
  onApplied?: (result: ApplyResult) => void;
}

export function useIaCapabilityAiAssist({
  targetKind,
  buildContext,
  onApplied,
}: UseIaCapabilityAiAssistOptions): CapabilityAiAssist {
  const client = React.useMemo(() => makeCapabilityAiClient(api), []);
  return useCapabilityAiAssistController({ client, targetKind, buildContext, onApplied });
}
